import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Configuration } from 'app/models/configuration/configuration';
import { MeasurementUnit } from 'app/models/measurement-unit/measurement-unit';
import { CartProduct } from 'app/models/product/cart-product/cart-product';
import { SimpleProduct } from 'app/models/product/product/simple-product';
import { SiteSettings } from 'app/pages/settings/settings-page/site-settings';
import { CartService } from 'app/services/cart/cart.service';
import { ConfigurationService } from 'app/services/configurations/configurations.service';
import { Paginator } from 'primeng/paginator';

@Component({
  selector: 'product-grid',
  templateUrl: './product-grid.component.html',
  styleUrls: ['./product-grid.component.scss']
})
export class ProductGridComponent implements OnInit, OnChanges {

  @Input() products: SimpleProduct[] = [];

  @Input() totalRecords: number;

  @Input() firstLoading: boolean;

  @Input() newSearchLoading: boolean;

  @Input() category: any;

  @Input() currentCategory: number;

  @Output() onPageEmit = new EventEmitter();

  @Output() onSortOrderEmit = new EventEmitter();

  @ViewChild('paginator') paginator: Paginator;

  @Input() sortOption: number;

  sortOptions = [
    { label: 'Preço Decrescente', value: 0 },
    { label: 'Preço Crescente', value: 1 },
    { label: 'Alfabética A-Z', value: 2 },
    { label: 'Alfabética Z-A', value: 3 },
  ];

  pageSize: number = 24;

  styleConfig = { backgroundColor: '', color: '', barColor: '', endBarColor: '' };

  loadingStyle: boolean = true;

  constructor(private _router: Router,
    private _configurationService: ConfigurationService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.currentCategory && this.paginator) {
      this.paginator.changePageToFirst(undefined);
    }
    this.adjustQuantityInProduct();
  }

  ngOnInit(): void {
    this.ckeckStyle();
  }

  ckeckStyle() {
    this.loadingStyle = true;
    let config = SiteSettings.getInstance().getConfiguration();

    if (config != null && config != undefined) {
      this.loadingStyle = false;
      this.setStyleConfig(config);
    } else {
      this._loadConfigServer();
    }
  }

  _loadConfigServer(): void {
    this._configurationService.getConfigurations().subscribe((value) => {
      SiteSettings.getInstance().setConfiguration(Configuration.fromJson(value.data));
      this.ckeckStyle();
    });
  }

  setStyleConfig(config: Configuration) {

    if (config.background.length > 0) {
      this.styleConfig.backgroundColor = config.background;
    }
    if (config.color.length > 0) {
      this.styleConfig.color = config.color;
    }
    if (config.shortcutBarColor.length > 0) {
      this.styleConfig.barColor = config.shortcutBarColor;
    }
    if (config.shortcutBarColorEnd.length > 0) {
      this.styleConfig.endBarColor = config.shortcutBarColorEnd;
    }

  }

  goToCategory(categoryCode?: number) {
    if (categoryCode || this.category.id)
      this._router.navigate(['pages/products'], { queryParams: { category: (categoryCode ?? this.category.id) } });
  }

  goToDetails(product: SimpleProduct) {
    sessionStorage.setItem('transitionalProduct', JSON.stringify(product));
    this._router.navigate([`pages/products/detail`], { queryParams: { productId: product.id, clasId: product.classificationId } });
  }

  getProductName(product: SimpleProduct): string {
    return product.classificationName != '' ? product.name + ' - ' + product.classificationName : product.name;
  }

  adjustQuantityInProduct() {
    if (!JSON.parse(localStorage.getItem('cart'))) return;
    const result: CartProduct[] = JSON.parse(localStorage.getItem('cart'));
    if (result.length < 0) return;
    for (let i = 0; i <= result.length - 1; i++) {
      let cartIndex = this.products.findIndex(e => e.id === result[i].item.id && e.classificationId === result[i].item.classificationId);
      if (cartIndex != -1) {
        this.products[cartIndex].selectedQuantity = result[i].cartQuantity;
      }
    }
  }

  pageEmit(event): void {
    this.onPageEmit.emit(event);
  }

  onSortChange(order): void {
    this.onSortOrderEmit.emit(order);
  }

  buildListElementMeasurementUnit(product: SimpleProduct): MeasurementUnit {
    let measurement = new MeasurementUnit();
    measurement.defaultUnit = true;
    measurement.measurementInitials = product.measurementUnitInitials;
    measurement.cartQuantity = product.selectedQuantity ?? 0;
    measurement.indexPrice = product.measurementUnitIndex ?? 1;
    measurement.quantity = product.measurementUnitQuantity ?? 1;
    return measurement;

  }

  updateProduct(incomingProduct: SimpleProduct): void {
    let index = this.products.findIndex((e) => {
      return e.id == incomingProduct.id && e.classificationId == incomingProduct.classificationId;
    })

    this.products[index].selectedQuantity = incomingProduct.selectedQuantity;
  }

  showMeasurementUnitDescription(product: SimpleProduct): boolean {
    return product.measurementUnitQuantity > 1;
  }
}
